import { render } from "./ModalVotacionVecinosAlLimite.vue?vue&type=template&id=60a46eee&scoped=true"
import script from "./ModalVotacionVecinosAlLimite.vue?vue&type=script&lang=js"
export * from "./ModalVotacionVecinosAlLimite.vue?vue&type=script&lang=js"

import "./ModalVotacionVecinosAlLimite.vue?vue&type=style&index=0&id=60a46eee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a46eee"]])

export default __exports__